import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { Footer } from './Footer';
import { Sidebar } from './Sidebar';
import { MobileMenu } from './MobileMenu';
import { styled } from '@mui/material/styles';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import MenuIcon from '@mui/icons-material/Menu';

const MainContent = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  paddingBottom: '120px', // Height of the footer
}));

interface ContentWrapperProps {
  isMobile: boolean;
}

const ContentWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<ContentWrapperProps>(({ theme, isMobile }) => ({
  flex: 1,
  marginLeft: isMobile ? '0' : '280px', // Width of the sidebar on desktop, 0 on mobile
  width: isMobile ? '100%' : 'calc(100% - 280px)', // Full width on mobile, sidebar-adjusted on desktop
  minHeight: '100%',
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

interface NavigationLayoutProps {
  children: React.ReactNode;
}

export const NavigationLayout: React.FC<NavigationLayoutProps> = ({ children }) => {
  const { isMobile } = useResponsiveLayout();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const handleOpenMobileMenu = () => {
    setMobileMenuOpen(true);
  };

  const handleCloseMobileMenu = () => {
    setMobileMenuOpen(false);
  };
  
  return (
    <MainContent>
      {!isMobile && <Sidebar />}
      {isMobile && (
        <Box
          sx={{
            position: 'fixed',
            top: 16,
            right: 16,
            zIndex: 1100,
            backgroundColor: 'rgba(38, 38, 38, 0.7)',
            borderRadius: '50%',
            backdropFilter: 'blur(4px)',
          }}
        >
          <IconButton
            onClick={handleOpenMobileMenu}
            sx={{ color: 'white' }}
            aria-label="open menu"
          >
            <MenuIcon />
          </IconButton>
        </Box>
      )}
      <MobileMenu open={mobileMenuOpen} onClose={handleCloseMobileMenu} />
      <ContentWrapper isMobile={isMobile}>
        {children}
      </ContentWrapper>
      <Footer />
    </MainContent>
  );
};
